import * as PIXI from "pixi.js";
import { Coord } from "../../types/Interface";


export function drawPencil(graph: PIXI.Graphics, color: number, sCoord: Coord = { x: 0, y: 0 }) {
    graph
      .clear()
      .moveTo(sCoord.x + 0, sCoord.y - 5)
      .roundPoly(sCoord.x + 0, sCoord.y - 5, 6, 3, 0, Math.PI)
      .rect(sCoord.x - 5, sCoord.y - 30, 10, 20)
      .rect(sCoord.x - 5, sCoord.y - 37, 10, 5)
      .fill(color);
  }